import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';

const GoogleIcon = () => (
  <Box
    component="svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    sx={{ width: 20, height: 20, display: 'block' }}
  >
    <path
      fill="#EA4335"
      d="M12 10.2v3.9h5.5c-.2 1.2-1.4 3.5-5.5 3.5-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.2 14.7 2.2 12 2.2c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8c5.7 0 9.5-4 9.5-9.6 0-.6-.1-1.1-.2-1.6H12z"
    />
    <path
      fill="#34A853"
      d="M2.2 7.8l3.2 2.3c.9-2.7 3.4-4.5 6.6-4.5 1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.9 3.2 14.7 2.2 12 2.2c-3.8 0-7.2 2.2-8.8 5.6z"
    />
    <path
      fill="#FBBC05"
      d="M12 21.8c2.6 0 4.8-.9 6.4-2.5l-3-2.5c-.8.6-2 1.1-3.4 1.1-3.1 0-5.7-2.1-6.6-4.9l-3.1 2.4c1.6 3.5 5.1 6.4 9.7 6.4z"
    />
    <path
      fill="#4285F4"
      d="M21.5 12.2c0-.6-.1-1.1-.2-1.6H12v3.9h5.5c-.3 1.2-1 2.1-2 2.8l3 2.5c1.7-1.6 2.9-3.9 2.9-7.6z"
    />
  </Box>
);

const SignIn = () => {
	const { root } = useSelector(state => state.api);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const signIn = name => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    window.location.href = `${root}/auth/${name}?url=${encodeURIComponent(window.location.href)}`;
  };

	return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        background:
          'linear-gradient(135deg, #f7f8fc 0%, #eef2ff 45%, #e0ecff 100%)'
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 460,
          bgcolor: '#ffffff',
          borderRadius: 4,
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 5 },
          boxShadow: '0 24px 70px rgba(23, 35, 79, 0.12)',
          border: '1px solid rgba(15, 23, 42, 0.07)',
          textAlign: 'center'
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 26, sm: 30 },
            fontWeight: 700,
            color: '#0f172a',
            mb: 1
          }}
        >
          Welcome back
        </Typography>
        <Typography
          sx={{
            fontSize: 15,
            color: '#64748b',
            lineHeight: 1.6,
            mb: 4
          }}
        >
          Continue with your Google account to access Hashely.
        </Typography>
        <Button
          onClick={() => signIn('google')}
          variant="contained"
          disableElevation
          disabled={isRedirecting}
          startIcon={
            <GoogleIcon />
          }
          sx={{
            width: '100%',
            maxWidth: 320,
            height: 52,
            mx: 'auto',
            borderRadius: 2.5,
            textTransform: 'none',
            fontSize: 16,
            fontWeight: 600,
            letterSpacing: '0.01em',
            color: '#0f172a',
            bgcolor: '#ffffff',
            border: '1px solid rgba(15, 23, 42, 0.10)',
            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: '#f8fafc',
              borderColor: 'rgba(15, 23, 42, 0.16)',
              transform: 'translateY(-1px)',
              boxShadow: '0 14px 28px rgba(15, 23, 42, 0.12)'
            },
            '& .MuiButton-startIcon': {
              mr: 1.2
            }
          }}
        >
          {isRedirecting ? 'Redirecting...' : 'Sign in with Google'}
        </Button>
      </Box>
    </Box>
  );
};

export default SignIn;